import { useNavigate } from "react-router-dom";
import { ErrorComponent, PageLayout } from "shared";
import ErrorImg from "assets/images/error-robot.png";
import { useAppScope } from "master/contexts";
import { PageNotFoundText } from "..";

export const PageNotFound = () => {
  const navigate = useNavigate();
  const { lanSettings } = useAppScope();

  const goToPreviousPage = () => {
    navigate(-1, { replace: true });
  };

  return (
    <PageLayout>
      <ErrorComponent
        title={`${PageNotFoundText.title[lanSettings?.lan || "en"]}`}
        message={`${PageNotFoundText.description[lanSettings?.lan || "en"]}`}
        image={ErrorImg}
        btnLabel={`${PageNotFoundText.button[lanSettings?.lan || "en"]}`}
        onClick={goToPreviousPage}
      />
    </PageLayout>
  );
};
